import { render, staticRenderFns } from "./ShowNotification.vue?vue&type=template&id=838ed11e"
import script from "./ShowNotification.vue?vue&type=script&lang=js"
export * from "./ShowNotification.vue?vue&type=script&lang=js"
import style0 from "./ShowNotification.vue?vue&type=style&index=0&id=838ed11e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports